import { useTranslation } from "react-i18next";
import { Link } from "@inertiajs/react";
import resolveLocaleRoute from "@/Helpers/resolveLocaleRoute";

const FrontNewsCta1 = ({ ...props }) => {
    const { t, i18n } = useTranslation();

    return (
        <div {...props}>
            <div className="flex flex-col gap-[20px] w-[234px] p-[20px] rounded-20 border border-30548A text-center">
                <img
                    src="/storage/icons/image_9.svg"
                    alt={t('alts.contactUs')}
                    width={46}
                    height={46}
                    className="mx-auto"
                    suppressHydrationWarning
                />

                <p className="font-semibold text-16 leading-[1.76]">{t('news_page.cta_1_text')}</p>

                <Link
                    href={resolveLocaleRoute('front.contact', null, i18n.resolvedLanguage)}
                    className="w-full py-[9px] px-[18px] border-30548A border-[1px] bg-30548A rounded-lg justify-center items-center gap-2.5 inline-flex text-white uppercase font-semibold text-13 transition-all ease-in-out duration-150 hover:bg-white hover:text-black"
                >
                    {t('news_page.cta_1_btn_text')}
                </Link>
            </div>
        </div>
    )
}

export default FrontNewsCta1;